import React from "react";

const ViewDetailsquaryModal = ({ isOpen, onClose, modelRequestData }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Background Overlay */}
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>

      {/* Modal Container */}
      <div className="bg-white rounded-lg shadow-lg z-10 p-6 sm:p-8 w-full sm:w-2/3 md:w-1/2 lg:w-1/3 max-h-[90vh] overflow-y-auto">
        <h2 className="text-lg sm:text-xl font-semibold mb-4 sm:mb-6">
          View Query Details
        </h2>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Remark
          </label>
          <p className="mt-1 text-gray-600 text-sm sm:text-base">
            {modelRequestData.remark}
          </p>
        </div>

        {/* Buttons */}
        <div className="flex justify-end">
          {/* <button
            type="button"
            className="mr-3 px-5 py-2 bg-gray-300 rounded-md hover:bg-gray-400 text-sm sm:text-base"
            onClick={onClose}
          >
            Cancel
          </button> */}
          <button
            type="button"
            className="text-white bg-[#E86B1B] rounded-md px-4 py-2 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
            onClick={onClose} // Static remark doesn't require form submission
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewDetailsquaryModal;
